import { TextInput } from '../baseInputs'

export default TextInput
